export const ALLERGEN_ID_NAME_MAP: any = {
  '1': 'gluten',
  '2': 'lactose',
  '3': 'eggs',
  '4': 'nuts',
  '5': 'soy',
  '6': 'sesameSeeds',
  '7': 'milk',
  '8': 'peanuts',
  '11': 'almonds',
  '17': 'fish',
  '18': 'sulfite',
  '22': 'wheat',
  '23': 'rye',
  '24': 'oats',
  '25': 'barley',
};

export const USER_ACCOUNT_TYPE = {
  GENERAL: 'GENERAL',
  SHARED_BUSINESS_ACCOUNT: 'SHARED_BUSINESS_ACCOUNT'
};

export const SEARCH_PRODUCTS_FILTERS_LOCAL_KEYS = {
  TAGS: 'tags',
  ALLERGENS: 'allergens',
  PRODUCT_GROUPS: 'productGroups',
  POST_NUMBER: 'postNumber',
  CAN_HAS_MOTIVE: 'canHasMotive',
  CATEGORY_ID: 'categoryId',
  REF_NAME: 'refName',
};

export const PAYMENT_STATUSES = {
  AWAITING_CUSTOMER: 'AWAITING_CUSTOMER',
  AWAITING_BAKERY: 'AWAITING_BAKERY',
  CONFIRMED: 'CONFIRMED',
  COMPLAINED: 'COMPLAINED',
  CANCELLED: 'CANCELLED',
};

export const NAVIGATION_BACK_TO_PAGES = {
  PAYMENT: 'payment',
  DELIVERY: 'DELIVERY'
};

export const MAX_ADVANCE_DAYS_FOR_THIRD_PARTY_DELIVERY = 30;

export enum PRODUCT_LAYOUT_MODE {
  GALLERY = 'GALLERY',
  LIST = 'LIST',
}
